<template>
  <div class="modal-user">
    <div class="body">
      <div class="slider">
        <div class="slider-title">
          <h4>Please rate the added insight</h4>
        </div>
        <div class="slider-body">
          <vue-slider
            v-model="value"
            :data="data"
            :marks="true"
          />
          <div class="buttons text-center">
            <button
              style="text-align: center; width: 250px"
              class="btn btn-primary mb-3 mt-5"
              @click="saveRateInsight">Add rate insight</button>
            <button
              style="text-align: center; width: 250px"
              class="btn btn-secondary mb-3"
              @click="closeModal">Skip</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import {mapActions} from "vuex";
import Form from "vform";
import Swal from "sweetalert2";
import profileMixin from "../../../mixins/profileMixin";
export default {
  components: {
    VueSlider,
  },
  mixins: [profileMixin],

  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: new Form({
        rates: '',
        insightId: this.item.type_id
      }),
      value: 'awful',
      data: ['awful', 'bad', 'okay', 'good', 'great'],
      show: false,
      params: {}
    }
  },

  watch: {
    value(val) {
      this.form['rates'] = val;
    }
  },

  methods: {
    ...mapActions(['updateInsightRate']),

    closeModal: function () {
      this.showModal()
    },
    saveRateInsight(){
      this.updateInsightRate(this.form).then(() => {
        Swal.fire(
            'Successfully!',
            'User added successfully.',
            'success'
        ).then(() => {
          this.showModal()
        })
      })
    }
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/modals/InsightRate/InsightRateModal.vue